import { render, staticRenderFns } from "./TimeLogNavigation.vue?vue&type=template&id=896f3ad6&"
import script from "./TimeLogNavigation.vue?vue&type=script&lang=js&"
export * from "./TimeLogNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports